import { render } from "./MusteriLoginView.vue?vue&type=template&id=04cd631a"
import script from "./MusteriLoginView.vue?vue&type=script&lang=js"
export * from "./MusteriLoginView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__